import { arrayOf, bool, func, node, oneOfType, shape, string } from "prop-types"

export const mapType = shape({
    className: string,
    borderRounded: bool,
    children: node,
    error: bool,
    id: string,
    isLoading: bool,
    bottomLeftElements: oneOfType([
        node,
        arrayOf(node),
    ]),
    bottomRightElements: oneOfType([
        node,
        arrayOf(node),
    ]),
    topRightElements: oneOfType([
        node,
        arrayOf(node),
    ]),
    onRecenter: func,
})